import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    try {
      const errorLog = {
        message: error?.message,
        stack: error?.stack?.split('\n').slice(0, 5).join('\n'),
        componentStack: errorInfo?.componentStack?.split('\n').slice(0, 5).join('\n'),
        timestamp: new Date().toISOString(),
        url: window.location.href,
      };
      console.error('[CHANTIX ErrorBoundary]', JSON.stringify(errorLog));
    } catch (_e) { void _e; }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/dashboard';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50" data-testid="error-boundary">
          <div className="text-center p-8 max-w-md">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Une erreur est survenue</h2>
            <p className="text-gray-600 mb-4">L'application a rencontré un problème inattendu.</p>
            <div className="flex flex-col gap-2">
              <button
                data-testid="error-boundary-retry"
                onClick={this.handleRetry}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Réessayer
              </button>
              <button
                data-testid="error-boundary-home"
                onClick={this.handleGoHome}
                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
              >
                Retour à l'accueil
              </button>
              <button
                data-testid="error-boundary-reload"
                onClick={this.handleReload}
                className="px-4 py-1 text-sm text-gray-500 hover:text-gray-700 transition-colors"
              >
                Recharger la page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
